import React, {Component} from 'react';
import {
  Button,
  Tooltip,
  Modal,
  Form,
  Row,
  Col,
  Tag
} from 'antd';
import {intToHexString, b64DecodeUnicode, intToHexVersion, timeConverterSimple} from '../utils'

const StationModalFormInfo = Form.create()((props) => {
  const {
    visible,
    station,
    showAction,
    onReboot,
    onSyncReq,
    onCancel
  } = props;
  const title = `Thông tin trạm ${station.Name}`
  const info = JSON.parse(b64DecodeUnicode(station.MoreInfo))
  return (<Modal visible={visible} title={title} onCancel={onCancel} footer={[<Button key="cancel" onClick={onCancel}>Bỏ qua</Button>
      ]}>
    <Row className="row">
      <Col span={8}>Tên</Col>
      <Col span={16}>{station.Name}</Col>
    </Row>
    <Row className="row">
      <Col span={8}>Mã</Col>
      <Col span={16}>{intToHexString(station.HardwareID)}</Col>
    </Row>
    <Row className="row">
      <Col span={8}>Firmware</Col>
      <Col span={16}>{intToHexVersion(station.FirmwareVersion)}</Col>
    </Row>
    <Row className="row">
      <Col span={8}>Kết nối server</Col>
      <Col span={16}>{
          station.OnlineState === 0
            ? <Tag color="gray">Mất kết nối</Tag>
            : <Tag color="green">Đang kết nối</Tag>
        }</Col>
    </Row>
    <Row className="row">
      <Col span={8}>Thời gian kết nối</Col>
      <Col span={16}>{timeConverterSimple(station.OnlineTime)}</Col>
    </Row>
    <Row className="row">
      <Col span={8}>Địa chỉ IP</Col>
      <Col span={16}>
        <a href={`http://${station.NetAddress}`} target="_blank">{station.NetAddress}:{station.NetPort}</a>
      </Col>
    </Row>
    <Row className="row">
      <Col span={8}>Địa bàn</Col>
      <Col span={16}>{
          station.GroupName
            ? station.GroupName
            : "Chưa cài đặt"
        }</Col>
    </Row>
    <Row className="row">
      <Col span={8}>Địa chỉ</Col>
      <Col span={16}>{info.addr}</Col>
    </Row>
    <Row className="row">
      <Col span={8}>Mô tả</Col>
      <Col span={16}>{info.desc}</Col>
    </Row>
    <Row className="row">
      <Col span={8}>Toạ độ</Col>
      <Col span={16}>{
          (info) || (info.lat === 0 || info.lng === 0)
            ? "Chưa cài đặt"
            : `${info.lng}, ${info.lat}`
        }</Col>
    </Row>
    {
      showAction
        ? <Row className="row">
            <Col span={8}></Col>
            <Col span={16}>
              <Tooltip placement="top" title="Đồng bộ dữ liệu">

                <Button type="primary" ghost="ghost" icon="sync" onClick={onSyncReq}></Button>
              </Tooltip>
              <Tooltip placement="top" title="Khởi động lại thiết bị">
                <Button type="primary" ghost="ghost" icon="reload" onClick={onReboot}></Button>
              </Tooltip>
            </Col>
          </Row>
        : null
    }
  </Modal>);
});

class StationButtonInfo extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };

  render() {
    const {showAction, onReboot, onSyncReq} = this.props
    return (<div>
      <Tooltip placement="top" title="Thông tin trạm">
        <Button type="primary" ghost="ghost" icon="info-circle-o" onClick={this.showModal}></Button>
      </Tooltip>
      <StationModalFormInfo visible={this.state.visible} station={this.props.station} showAction={showAction} onReboot={onReboot} onSyncReq={onSyncReq} onCancel={this.handleCancel}/>
    </div>);
  }
}

export default StationButtonInfo;



// WEBPACK FOOTER //
// ./src/components/StationButtonInfo.js